/* eslint-disable max-lines */
import { HYBRID_LP } from './../../Hlp/HybridProductCard/constants';
import { AddToWishlistResponse } from 'store/wishlist/transformer';
import { addToWishlist, removeFromWishlist } from 'store/wishlist/action';
import { getPageSource } from 'store/addToCart/helpers';
import { getTagsData } from 'components/ProductList/helper';
import { OfferData } from 'types/productCard';
import {
  trackAddToWishlist,
  trackRemoveFromWishlist,
} from 'store/wishlist/helpers';
import { AddToCartParams } from 'store/addToCart/action';
import {
  standardErrorMessages,
  NO_OFFER_MESSAGE,
  NO_OFFER_ID,
  PRODUCT_ADDED_TO_WISHLIST,
  PRODUCT_REMOVED_FORM_WISHLIST,
  ADD_TO_CART,
} from 'shared/constants';
import { ListingProduct } from 'shared/store/categoryListing/types';
import {
  pushEvent,
  pushData,
  getNavigationTrackingParams,
} from '@nykaa/data-layer';
import { PDP_COMBO_WIDGET } from 'shared/constants/dataLayer';
import { pages } from 'constants/urls';
import { CAB_SECTION_ID } from 'shared/constants/productPage';
import { productCardAction } from 'helpers/utils/vernacular/tracking';
import {
  WishlistActionProps,
  AddToCartActionProps,
  BuyNowActionProps,
} from './types';
import { GOTO_BAG_SHOWN } from './constants';
import { ProductWidgetTrackingProps } from 'components/CartOperations';
import { getViewBagPageSource } from 'components/Header/RightNav/Notification/helpers';
import { isDeviceAndroid, isDeviceNotWeb } from 'helpers/utils/device';
import { webViewCallbacks } from '@nykaa/webview-wizard/constant';
import { webViewCallbackhandler } from '@nykaa/webview-wizard';
import { isValidArrayLength } from '@nykaa/utils/validations';
import { showSignUp } from 'store/app/actions';
import { getUpdatedTrackingKeys, pushBuyNowClicked } from './helper';
import { LOGIN_LOCATION } from 'constants/auth';
import { setLoginLocation } from 'store/auth/helper';

const COMBO_QUERY_PARAM = 'combo';
const REDIRECT_FROM = 'rf';
const SCROLL_BEHAVIOR = 'smooth';
const GO_TO_BAG = 'Go To Bag';

export const handleAddToCart = async ({
  productPage,
  onErrorAddToBag = () => {},
  isLoading,
  setIsLoading,
  product,
  user,
  doAddToCart,
  dispatch,
  handleAddToCartTracking,
  ctaText,
  setAddToBagError,
  setAddToBagMessage,
  lang,
  isExperimentEnabled,
  clickedFrom,
  ITEM_ADDED_TO_CART,
  setCouponPopupHeader,
  setCouponsAppliedList,
  isDefaultSelected = true,
  isFirstFoldExp,
  isGoToBag,
  setIsGoToBag = () => {},
  setNewCtaText = () => {},
  preloadTillRecommendations,
  multiCouponsEnabled,
  trackAddToCartData,
  isPdpCtaExpEnabled,
  journeyData,
  isHlpCtaExpEnabled,
  handlePostAddToCart,
  setDealDeltaText,
  isConvenienceFeeEnabled,
  isConvSearch,
  appTrackingKeys,
  onStepperCountChanged,
  readUrlParamsForTracking = false,
}: AddToCartActionProps) => {
  const {
    offer: offerMessage = NO_OFFER_MESSAGE,
    offerId = NO_OFFER_ID,
    showOffer = false,
  } = product;
  if (
    !isDefaultSelected &&
    productPage?.variants?.length &&
    !productPage?.selectedVariantId
  ) {
    onErrorAddToBag && onErrorAddToBag();
    pushEvent('addToBag-withoutSize');
  } else {
    if (!isLoading) {
      let { siteNavigation = '', siteSubNavigation = '' } = journeyData || {};

      const queryParams = new URLSearchParams(location.search);
      if (queryParams.get(REDIRECT_FROM) === COMBO_QUERY_PARAM) {
        siteNavigation = PDP_COMBO_WIDGET;
        siteSubNavigation = `${PDP_COMBO_WIDGET}:${product?.name}`;
        pushData({
          pageName: PDP_COMBO_WIDGET,
          siteNavigation,
          siteSubNavigation,
        });
      }
      // handle PLP is_best_price_eligible for add to cart
      pushData({
        isListingBestPriceEligible: product?.bestPrice ? true : false,
      });
      let updatedSiteNav = siteNavigation;
      let updatedSiteSubNav = siteSubNavigation;
      if (readUrlParamsForTracking) {
        ({ updatedSiteNav, updatedSiteSubNav } = getUpdatedTrackingKeys({
          siteNavigation,
          siteSubNavigation,
          queryParams,
        }));
      }
      const trackingParamsUpdated = getNavigationTrackingParams(
        updatedSiteNav,
        updatedSiteSubNav
      );
      const params: AddToCartParams = {
        productId: product.childId,
        isPro: user.isPro,
        trackingParam: {
          ...trackingParamsUpdated,
        },
      };
      if (isConvSearch && params.trackingParam) {
        params.trackingParam.site_navigation =
          appTrackingKeys?.site_navigation || '';
        params.trackingParam.site_sub_navigation =
          appTrackingKeys?.site_sub_navigation || '';
      }
      setIsLoading(true);
      try {
        let cartData;
        if (!isGoToBag) {
          cartData = await dispatch(
            doAddToCart(params, isConvenienceFeeEnabled)
          );
          if (handlePostAddToCart) handlePostAddToCart(1);
          if (onStepperCountChanged && isValidArrayLength(cartData?.items)) {
            const cartItem = cartData.items.find(
              (item) => item.productId === product.childId
            );
            if (cartItem) {
              onStepperCountChanged(product.childId, cartItem.quantity);
            }
          }
          if (cartData && cartData.dealDeltaText && setDealDeltaText) {
            setDealDeltaText(cartData.dealDeltaText);
          }
          handleAddToCartTracking(cartData, product, trackAddToCartData);
        }
        if (
          !isGoToBag &&
          (isFirstFoldExp || isPdpCtaExpEnabled || isHlpCtaExpEnabled)
        ) {
          setNewCtaText(GO_TO_BAG);
          if (isHlpCtaExpEnabled) {
            pushEvent(GOTO_BAG_SHOWN);
          }
          setIsGoToBag(true);
        }
        const pageSource = getViewBagPageSource();
        if ((ctaText && !isFirstFoldExp) || isGoToBag) {
          if (isPdpCtaExpEnabled) {
            window.location.href = `${pages.CHECKOUT_PAGE}?rf=productDetailPage_GotoBag:ViewBag&source=${pageSource}`;
            return;
          }
          if (isHlpCtaExpEnabled) {
            window.location.href = `${pages.CHECKOUT_PAGE}?rf=productDetailPage:hlp:gotobag&source=${pageSource}`;
            return;
          }
          window.location.href = `${pages.CHECKOUT_PAGE}?source=${pageSource}`;
        } else {
          setAddToBagError(false);
          if (
            multiCouponsEnabled &&
            cartData.couponAppliedText &&
            setCouponPopupHeader
          ) {
            pushEvent('pdp:AddToBagAutoApplied', {
              couponAutoApplied: 1,
              couponDetails: cartData.couponAppliedList,
              pageViewLocation: 'autoApplied:PDP',
            });
            setCouponPopupHeader(cartData.couponAppliedText);
            if (cartData.couponAppliedList && setCouponsAppliedList) {
              setCouponsAppliedList(cartData.couponAppliedList);
            }
          } else {
            if (!isFirstFoldExp) {
              setAddToBagMessage(ITEM_ADDED_TO_CART);
            }
          }

          if (preloadTillRecommendations) {
            preloadTillRecommendations();
          } else {
            const cabSectionNode =
              document?.getElementById(CAB_SECTION_ID) ||
              document?.getElementsByClassName(CAB_SECTION_ID)[0];
            if (cabSectionNode) {
              cabSectionNode.scrollIntoView({ behavior: SCROLL_BEHAVIOR });
            }
          }
        }
        if (lang && isExperimentEnabled) {
          const trackingOptions = {
            eventName: ADD_TO_CART,
            isExperimentEnabled,
            product,
            clickedFrom,
            lang,
            action: ADD_TO_CART,
            offerMessage,
            offerId,
            showOffer,
          };
          productCardAction(trackingOptions);
        }
      } catch (e) {
        if (e.errorInApi) {
          setAddToBagMessage(e.message);
        } else {
          setAddToBagMessage(standardErrorMessages.SOMETHING_WRONG);
        }
        setAddToBagError(true);
      } finally {
        setIsLoading(false);
      }
    }
  }
  return;
};

export const wishlistAdd = async (
  {
    dispatch,
    setIsInWishlist,
    setWishlistMessage,
    setWishlistError,
    pageLocation,
    primaryCategories,
    brandName,
    videoId,
    product,
    user,
    pwPageSource,
    trackingData,
    productData,
    gptConversationId,
    isConvSearch,
    appTrackingKeys,
    device,
  }: WishlistActionProps,
  productWidgetProps?: ProductWidgetTrackingProps
) => {
  setIsInWishlist(true);
  try {
    const tags = getTagsData(product as ListingProduct);
    const showOffer = product.showOffer;
    const wishlistData: AddToWishlistResponse = await addToWishlist({
      productId: product.childId,
      formKey: user.formKey,
    })(dispatch);
    const isWishlistAddSuccess = !!wishlistData;
    if (isWishlistAddSuccess && isDeviceNotWeb(device)) {
      const action = 'add';
      const appParams = {
        device,
        callbackFunctionName: webViewCallbacks.updateWishlistProduct,
        callbackParams: isDeviceAndroid(device)
          ? {
              productId: product.childId,
              action: action,
            }
          : {
              product_id: product.childId,
              action: action,
            },
      };
      webViewCallbackhandler(appParams);
    }
    setWishlistError(false);
    setWishlistMessage(PRODUCT_ADDED_TO_WISHLIST);
    let pageSource = pwPageSource
      ? pwPageSource
      : getPageSource({ pageLocation, productId: product.id });

    const widgetPageSource = () => {
      if (!pageSource && pageLocation?.pageType) {
        return pageLocation.pageType;
      }
    };
    if (window.dataLayer.page === HYBRID_LP) {
      pageSource = HYBRID_LP;
    }
    const offerData: OfferData = {};
    if (showOffer) {
      offerData.offerMessage = product?.offer || NO_OFFER_MESSAGE;
      offerData.offerId = product?.offerId || NO_OFFER_ID;
    }
    const defaultWishlistData = {
      ...wishlistData,
      pageSource,
    };
    const variants = productData?.variants;
    const inStockVariants = variants?.filter(
      (item) => item.inStock === true
    ).length;
    const oosVariants = variants?.length - inStockVariants;
    trackAddToWishlist(
      {
        ...defaultWishlistData,
        product: {
          id: product.childId,
          parentId: product.parentId || productData?.id,
          brandName: brandName,
          mrp: product.mrp,
          offerPrice: product.offerPrice || product.price,
          discount: product.discount,
          productId: product.parentId || productData?.id,
          name: product.name,
          primaryCategories,
          featured: product.featured,
          isLux: product.isLux,
          inStock: product.inStock,
          sku: product.sku,
          type: product.type || productData?.productType,
          variantCount: product.variantCount || productData?.variants?.length,
          variantType: product.variantType || productData?.variantType,
          cohortSaleTemplate: product.cohortSaleTemplate,
          cohortSaleTemplateV2: product.cohortSaleTemplateV2,
          inStockVariants,
          oosVariants,
          tags,
          showOffer,
          ...offerData,
        },
        pageSource: pageSource || widgetPageSource(),
        videoId,
        trackingData,
        gptConversationId,
        isConvSearch,
        appTrackingKeys,
      },
      productWidgetProps
    );
  } catch (e) {
    setWishlistMessage(standardErrorMessages.SOMETHING_WRONG);
    setWishlistError(true);
    setIsInWishlist(false);
    throw e;
  }
};

export const wishlistRemove = async (
  {
    dispatch,
    setIsInWishlist,
    setWishlistMessage,
    setWishlistError,
    brandName,
    product,
    pageLocation,
    pwPageSource,
    trackingData,
    productData,
    gptConversationId,
    isConvSearch,
    appTrackingKeys,
    interactionInfo,
    device,
  }: WishlistActionProps,
  productWidgetProps?: ProductWidgetTrackingProps
) => {
  setIsInWishlist(false);
  try {
    const tags = getTagsData(product as ListingProduct);
    const showOffer = product.showOffer;
    const isWishlistRemoveSuccess = await removeFromWishlist({
      productId: product.childId,
    })(dispatch);
    const offerData: OfferData = {};
    if (showOffer) {
      offerData.offerMessage = product?.offer || NO_OFFER_MESSAGE;
      offerData.offerId = product?.offerId || NO_OFFER_ID;
    }
    if (isWishlistRemoveSuccess && isDeviceNotWeb(device)) {
      const action = 'remove';
      const appParams = {
        device,
        callbackFunctionName: webViewCallbacks.updateWishlistProduct,
        callbackParams: isDeviceAndroid(device)
          ? {
              productId: product.childId,
              action: action,
            }
          : {
              product_id: product.childId,
              action: action,
            },
      };
      webViewCallbackhandler(appParams);
    }

    setWishlistError(false);
    setWishlistMessage(PRODUCT_REMOVED_FORM_WISHLIST);
    const variants = productData?.variants;
    const inStockVariants = variants?.filter(
      (item) => item.inStock === true
    ).length;
    const oosVariants = variants?.length - inStockVariants;
    const pageSource = pwPageSource
      ? pwPageSource
      : getPageSource({ pageLocation, productId: product.id });

    const widgetPageSource = () => {
      if (!pageSource && pageLocation?.pageType) {
        return pageLocation.pageType;
      }
    };
    trackRemoveFromWishlist(
      {
        product: {
          id: product.childId,
          parentId: product.parentId || productData?.id,
          brandName: brandName,
          mrp: product.mrp,
          discount: product.discount,
          productId: product.parentId || productData?.id,
          offerPrice: product.offerPrice || product.price,
          name: product.name,
          categoryLevel: product.primaryCategories,
          featured: product.featured,
          inStock: product.inStock,
          sku: product.sku,
          type: product.type || productData?.productType,
          variantCount: product.variantCount || variants?.length,
          variantType: product.variantType || productData?.variantType,
          inStockVariants,
          oosVariants,
          tags,
          showOffer,
          pageSource: pageSource || widgetPageSource(),
          trackingData,
          ...offerData,
        },
        gptConversationId,
        isConvSearch,
        appTrackingKeys,
        interactionInfo,
      },
      productWidgetProps
    );
  } catch (error) {
    setWishlistMessage(standardErrorMessages.SOMETHING_WRONG);
    setWishlistError(true);
    setIsInWishlist(true);
  }
};

export const handleBuyNow = async ({
  productPage,
  onErrorAddToBag = () => {},
  buyNowLoading,
  setBuyNowLoading,
  product,
  user,
  doAddToCartAndRefresh,
  dispatch,
  setAddToBagError,
  setAddToBagMessage,
  isDefaultSelected = true,
  isConvenienceFeeEnabled,
  showBuyNow,
  isLoggedIn,
}: BuyNowActionProps) => {
  const isBuyNowWithoutSize =
    !isDefaultSelected &&
    productPage?.variants?.length &&
    !productPage?.selectedVariantId;
  const bottomSheetAlreadyShown =
    sessionStorage.getItem('BottomSheetShown') === 'true';
  if (showBuyNow && !isLoggedIn && !bottomSheetAlreadyShown) {
    pushBuyNowClicked(true);
    setLoginLocation(LOGIN_LOCATION.BUY_NOW);
    dispatch(showSignUp());
    sessionStorage.setItem('BottomSheetShown', 'true');
    return;
  }
  if (isBuyNowWithoutSize) {
    onErrorAddToBag && onErrorAddToBag();
  } else {
    if (!buyNowLoading) {
      const params: AddToCartParams = {
        productId: product.childId,
        isPro: user.isPro,
        buyNow: true,
      };
      setBuyNowLoading(true);
      try {
        await dispatch(
          doAddToCartAndRefresh(params, isConvenienceFeeEnabled, true)
        );
        window.location.href = '/v2/payment?buyNow=true';
      } catch (e) {
        if (e.errorInApi) {
          setAddToBagMessage(e.message);
        } else {
          setAddToBagMessage(standardErrorMessages.SOMETHING_WRONG);
        }
        setAddToBagError(true);
      } finally {
        setBuyNowLoading(false);
      }
    }
  }
  return;
};
